import { Box, Link, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router";

import { articleTypeLabel, formatLearnLabel } from "./learnLabels";

export default function LearnBreadcrumbs({ article }) {
  const items = [
    { label: "Learn", to: "/learn" },
    article?.article_type ? { label: articleTypeLabel(article.article_type) } : null,
    article?.category ? { label: formatLearnLabel(article.category) } : null,
  ].filter(Boolean);

  return (
    <Box
      aria-label="Breadcrumb"
      sx={{
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        gap: 0.75,
        mb: 2.5,
        color: "text.secondary",
      }}
    >
      {items.map((item, index) => (
        <Box key={`${item.label}-${index}`} sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
          {index > 0 ? (
            <Typography component="span" variant="body2" color="text.secondary">
              /
            </Typography>
          ) : null}
          {item.to ? (
            <Link component={RouterLink} to={item.to} underline="hover" variant="body2" sx={{ fontWeight: 800 }}>
              {item.label}
            </Link>
          ) : (
            <Typography component="span" variant="body2" color="text.secondary" sx={{ fontWeight: 700 }}>
              {item.label}
            </Typography>
          )}
        </Box>
      ))}
    </Box>
  );
}
